import React from 'react';
import { Router, RouteComponentProps } from '@reach/router';

import Index from './pages/Index';
import './App.css';
import './types/index.d.ts';
import { Address } from './pages/Address';
import './App.less';
import PaySuccess from './pages/PaySuccess';
import SignGroup from './pages/SignGroup';

const RoutePage = (props: RouteComponentProps & { component: any }) => {
  const Comp = props.component;
  return <Comp {...props} />;
}

const App = () => {
  // @ts-ignore
  return <Router basepath='/activity/club'>
    <RoutePage path='/' component={Index} />
    <RoutePage path='/:activity_id' component={Index} />
    <RoutePage path='/address' component={Address} />
    <RoutePage path='/paySuccess' component={PaySuccess} />
    <RoutePage path='/signGroup' component={SignGroup} />
    
  </Router>
}
export default App;

